import PropTypes from 'prop-types';
import { forwardRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

// project import
import { activeItem } from 'store/reducers/menu';
import UpIcon from '../../../../assets/static_images/up.svg';
import DownIcon from '../../../../assets/static_images/down.svg';
import Grid from '@mui/material/Unstable_Grid2';

// ==============================|| NAVIGATION - LIST ITEM ||============================== //

const SubNavItem = ({ item, level, collapse, setCollapse }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const menu = useSelector((state) => state.menu);
    // const { drawerOpen, openItem } = menu;
    let drawerOpen = true;
    let openItem = [];
    let itemTarget = '_self';
    if (item.target) {
        itemTarget = '_blank';
    }

    let listItemProps = { component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item.url} target={itemTarget} />) };
    if (item?.external) {
        listItemProps = { component: 'a', href: item.url, target: itemTarget };
    }

    const itemHandler = (id) => {
        setCollapse((entry) => {
            return !entry;
        });
        dispatch(activeItem({ openItem: [id] }));
    };

    const Icon = item.icon;
    const itemIcon = item.icon ? <Icon style={{ fontSize: drawerOpen ? '1rem' : '1.25rem' }} /> : false;

    const isSelected = openItem.findIndex((id) => id === item.id) > -1;

    // active menu item on page load
    useEffect(() => {
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex((id) => id === item.id);
        if (currentIndex > -1) {
            dispatch(activeItem({ openItem: [item.id] }));
        }
        // eslint-disable-next-line
    }, []);

    const textColor = 'text.primary';
    const iconSelectedColor = 'primary.main';

    return (
        <ListItemButton
            {...listItemProps}
            disabled={item.disabled}
            onClick={() => itemHandler(item.id)}
            selected={false}
            sx={{
                zIndex: 0,
                pl: drawerOpen ? `${level * 28}px` : 1.5,

                ...(drawerOpen && {
                    '&:hover': {
                        bgcolor: 'primary.light',
                        background: 'linear-gradient(90deg, rgba(30, 124, 136, .1) 0%, rgba(30, 124, 136, 0) 100%)',
                        color: 'primary.main',
                        borderLeft: `3px solid ${theme.palette.primary.main}`
                    },
                    '&.Mui-selected': {
                        bgcolor: 'primary.light',
                        background: 'linear-gradient(90deg, rgba(30, 124, 136, .1) 0%, rgba(30, 124, 136, 0) 100%)',
                        color: 'primary.main',
                        borderLeft: `3px solid ${theme.palette.primary.main}`
                    }
                }),
                ...(!drawerOpen && {
                    '&:hover': {
                        bgcolor: 'transparent'
                    },
                    '&.Mui-selected': {
                        '&:hover': {
                            bgcolor: 'transparent'
                        },
                        bgcolor: 'transparent'
                    }
                })
            }}
        >
            {(drawerOpen || (!drawerOpen && level !== 1)) && (
                <Grid container lg={11} sm={12} display="flex" justifyContent="between" alignItems="center">
                    <Grid item sm={10.5}>
                        <ListItemText
                            primary={
                                <Typography
                                    variant="subtitle"
                                    sx={{
                                        color: isSelected ? 'rgba(0, 0, 0, 0.87)' : 'rgba(0, 0, 0, 0.87)',
                                        fontSize: { md: '16px', xs: '14px' }
                                    }}
                                >
                                    {item.title}
                                </Typography>
                            }
                        />
                    </Grid>
                    <Grid item display="flex" alignItems="center" justifyContent="end" sx={{ marginLeft: '.4rem' }} lg={1} sm={1.4}>
                        {collapse ? (
                            <img style={{ flexShrink: 0 }} src={DownIcon} className="img-fit" alt="up" />
                        ) : (
                            <img style={{ flexShrink: 0 }} src={UpIcon} className="img-fit" alt="up" />
                        )}
                    </Grid>
                </Grid>
            )}
        </ListItemButton>
    );
};

SubNavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default SubNavItem;
